import { render } from "./SignButton.vue?vue&type=template&id=520339f7&scoped=true"
import script from "./SignButton.vue?vue&type=script&lang=js"
export * from "./SignButton.vue?vue&type=script&lang=js"

import "./SignButton.vue?vue&type=style&index=0&id=520339f7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520339f7"]])

export default __exports__